import React, { useEffect, useState } from "react";
import { Alert, Col, DatePicker, Divider, Form, Input, Modal, notification, Row, Select } from "antd";
import { useAtom } from "jotai";
import {
  colaboradorAtom,
  visibleModalActivarColaboradorAtom,
  visibleModalExitoAtom,
} from "../../LegajoColaboradorStore";
import { WarningOutlined } from "@ant-design/icons";
import { OnboardingIngresoColaboradorService } from "services/OnboardingIngresoColaboradorService";
import moment from "moment/moment";
import { OnboardingColaboradorService } from "services/OnboardingColaboradorService";
import { LoginService } from "services/LoginService";

const ModalActivarColaborador = () => {
  const [visible, setVisible] = useAtom(visibleModalActivarColaboradorAtom);
  const [, setVisibleModalExito] = useAtom(visibleModalExitoAtom);
  const [colaboradorSeleccionado, setColaboradorSeleccionado] = useAtom(colaboradorAtom);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tieneDocumentosPendientes, setTieneDocumentosPendientes] = useState(false);
  const [documentosFaltantes, setDocumentosFaltantes] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (visible) {
        const response =
          await
            OnboardingColaboradorService
              .listarEnvioOnboarding(
                colaboradorSeleccionado.numeroDocumentoIdentidad,
                null,
                null,
                null,
                null,
                null,
                null,
                LoginService.getUsuarioAutenticado().login,
                0);

        const envios = response.envios;

        if (envios && envios.length > 0) {
          let pendientes = 0;

          for (const envio of envios) {
            pendientes += envio.resumenOnboarding.pendientes;
          }

          if (pendientes > 0) {
            setTieneDocumentosPendientes(true);
          } else {
            setTieneDocumentosPendientes(false);
          }
        }

        const documentosFaltantesActivacion =
          await OnboardingIngresoColaboradorService.listarDocumentosFaltantesParaActivar(
            colaboradorSeleccionado.numeroDocumentoIdentidad
          );
        setDocumentosFaltantes(documentosFaltantesActivacion.documentosFaltantes || []);

      } else {
        setDocumentosFaltantes([]);
      }
    }
    fetchData();
  }, [visible])

  const onClickBtnActivar = () => {
    form
      .validateFields()
      .then(async (formulario) => {
        try {
          setLoading(true);
          const response = await OnboardingIngresoColaboradorService.activarColaborador({
            ...formulario,
            numeroDocumentoIdentidad: colaboradorSeleccionado.numeroDocumentoIdentidad,
          });
          if (response) {
            setColaboradorSeleccionado({ ...colaboradorSeleccionado, estadoRegistro: "ACTIVO" });
            setVisible(false);
            setVisibleModalExito(true);
          }
        } catch (error) {
          console.error("No se pudo activar el postulante", error);
          notification.error({
            message: "No se pudo activar al postulante",
            description: error?.response?.data?.mensaje || "Ocurrió un error inesperado. Intente nuevamente.",
          });
        } finally {
          setLoading(false);
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const onClickBtnCancelar = () => {
    setVisible(false);
  };

  return (
    <Modal
      title="Activar Usuario"
      destroyOnClose={true}
      maskClosable={false}
      open={visible}
      okText="Activar"
      onOk={onClickBtnActivar}
      onCancel={onClickBtnCancelar}
      confirmLoading={loading}
      okButtonProps={{ disabled: documentosFaltantes.length > 0 }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "0px 60px",
        }}
      >
        <WarningOutlined style={{ fontSize: "48px", color: "#faad14" }} />

        <span style={{ fontSize: "20px", color: "#4a4e69", textAlign: "center" }}>
          ¿Está seguro de activar al postulante?
        </span>

        <span style={{ textAlign: "center", color: "#6d6875" }}>
          Complete y confirme la siguiente información:
        </span>

        {documentosFaltantes.length > 0 &&
          <Alert
            type="error"
            message="No se puede activar: faltan documentos obligatorios por completar"
            description={
              <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                <ul style={{ paddingLeft: "18px", margin: 0 }}>
                  {documentosFaltantes.map((documento) => (
                    <li key={documento}>{documento}</li>
                  ))}
                </ul>
              </div>
            }
            showIcon
            style={{ marginTop: "5px", width: "100%" }}
          />
        }

        {tieneDocumentosPendientes &&
          <Alert
            type="warning"
            message="El postulante aún tiene documentos pendientes de completar y/o subir."
            showIcon
            style={{ marginTop: "5px" }}
          />
        }

        <Divider style={{ margin: "12px 0" }} />
        <div style={{ width: "100%", marginBottom: "10px" }}>
          <Form layout="vertical" form={form}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="fechaIngreso"
                  label="Fecha Ingreso"
                  rules={[{ required: true }]}
                  initialValue={
                    colaboradorSeleccionado?.fechaIngreso
                      ? moment(colaboradorSeleccionado?.fechaIngreso, "DD/MM/YYYY")
                      : undefined
                  }
                >
                  <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>



      </div>
    </Modal>
  );
};

export default ModalActivarColaborador;
